import React, { FC } from 'react';
import { cx } from 'emotion';
import { Icon } from '@surveycake/rc';
import { checkSquareFilled } from '@surveycake/rc';
import { squareOutlined } from '@surveycake/rc';
import { useStyles } from './styles';

export interface CheckboxProps {
  checked: boolean;
}

const Checkbox: FC<CheckboxProps> = ({ checked }) => {
  const styles = useStyles([checked]);

  return (
    <Icon
      className={cx('Checkbox', styles.icon)}
      icon={checked ? checkSquareFilled : squareOutlined}
    />
  );
};
export default Checkbox;
